(() => {
  'use strict';

  if (window.__mascalmaNavigationCartLoaded) return;
  window.__mascalmaNavigationCartLoaded = true;

  const sectionNames = ['cart-drawer', 'cart-icon-bubble'];

  const syncDrawerEmptyState = (cartDrawer) => {
    if (!cartDrawer) return;

    const drawerItems = cartDrawer.querySelector('cart-drawer-items');
    const isEmpty = !drawerItems || drawerItems.classList.contains('is-empty');

    cartDrawer.classList.toggle('is-empty', isEmpty);
  };

  const patchCartDrawerRendering = () => {
    const CartDrawerElement = customElements.get('cart-drawer');
    if (!CartDrawerElement) return;

    const prototype = CartDrawerElement.prototype;

    if (prototype.__mascalmaEmptyStatePatched) return;

    const originalRenderContents = prototype.renderContents;
    if (typeof originalRenderContents !== 'function') return;

    prototype.renderContents = function renderContentsWithMascalmaState(parsedState) {
      const result = originalRenderContents.call(this, parsedState);

      syncDrawerEmptyState(this);

      return result;
    };

    prototype.__mascalmaEmptyStatePatched = true;

    syncDrawerEmptyState(document.querySelector('cart-drawer'));
  };

  if (customElements.get('cart-drawer')) {
    patchCartDrawerRendering();
  } else {
    customElements
      .whenDefined('cart-drawer')
      .then(patchCartDrawerRendering);
  }

  const getRoute = (routeName, fallbackPath) => {
    if (window.routes && window.routes[routeName]) {
      return window.routes[routeName];
    }

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

    return `${normalizedRoot}${fallbackPath.replace(/^\/+/, '')}`;
  };

  const requestCartChange = async (toggle) => {
    const protection = toggle.closest('[data-mascalma-protection]');
    const cartDrawer = document.querySelector('cart-drawer');

    if (
      !protection ||
      !cartDrawer ||
      typeof cartDrawer.renderContents !== 'function'
    ) {
      return;
    }

    const variantId = Number(protection.dataset.variantId);
    const lineKey = protection.dataset.lineKey;
    const shouldAdd = toggle.checked;
    const previousState = !shouldAdd;
    const errorElement = protection.querySelector(
      '#MascalmaProtectionError'
    );

    if (
      shouldAdd &&
      (!Number.isInteger(variantId) || variantId <= 0)
    ) {
      toggle.checked = previousState;
      return;
    }

    if (!shouldAdd && !lineKey) {
      toggle.checked = previousState;
      return;
    }

    protection.setAttribute('aria-busy', 'true');
    toggle.disabled = true;

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    const body = shouldAdd
      ? {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _mascalma_shipping_protection: 'Sí',
              },
            },
          ],
          sections: sectionNames,
          sections_url: window.location.pathname,
        }
      : {
          id: lineKey,
          quantity: 0,
          sections: sectionNames,
          sections_url: window.location.pathname,
        };

    const endpoint = shouldAdd
      ? getRoute('cart_add_url', 'cart/add.js')
      : getRoute('cart_change_url', 'cart/change.js');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(
          parsedState.description ||
            parsedState.message ||
            'No se pudo actualizar la protección.'
        );
      }

      if (!parsedState.sections) {
        throw new Error(
          'Shopify no devolvió el contenido actualizado del carrito.'
        );
      }

      cartDrawer.renderContents(parsedState);
    } catch (error) {
      toggle.checked = previousState;
      toggle.disabled = false;
      protection.removeAttribute('aria-busy');

      if (errorElement) {
        errorElement.textContent =
          error instanceof Error
            ? error.message
            : 'No se pudo actualizar la protección. Inténtalo de nuevo.';

        errorElement.hidden = false;
      }
    }
  };

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest(
      '[data-mascalma-protection-toggle]'
    );

    if (!toggle) return;

    requestCartChange(toggle);
  });
})();